"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defloydInsightPercentiles = exports.useMarketInsight = exports.fromFloyd = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const api_1 = __importDefault(require("../api"));
// as always be wary of float maths, this seems to work as required (for now)
// previous interations appended string zeros and regex replaced a decimal when detecting 4 digits.
const fromFloyd = (floydPrice) => (Number(floydPrice) || 0) / 10000;
exports.fromFloyd = fromFloyd;
const useMarketInsight = (propertyId) => {
    const [insight, setInsight] = react_1.default.useState(null);
    const loading = (0, merlin_hooks_1.useDataLoad)(!insight, () => api_1.default.marketInsight.getPricingByPropertyId(propertyId)
        .catch(() => setInsight(null))
        .then((resp) => setInsight(resp.pricing)));
    return { loadingInsight: loading, insight: (0, exports.defloydInsightPercentiles)(insight) };
};
exports.useMarketInsight = useMarketInsight;
const defloydInsightPercentiles = (insights) => {
    if (!insights)
        return insights;
    const insightsCopy = (0, lodash_1.cloneDeep)(insights);
    Object.entries(insightsCopy.rate_percentiles).forEach(([key, value]) => insightsCopy.rate_percentiles[key] = (0, exports.fromFloyd)(value));
    return insightsCopy;
};
exports.defloydInsightPercentiles = defloydInsightPercentiles;
//# sourceMappingURL=useMarketInsight.js.map